import './Status.less';

export const prefix = 'bm-c-status';

export { default } from './Status';
